import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const RiskDegerlendirmesiPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'Risk Değerlendirmesi | Adana OSGB Mersin Hatay Osmaniye | ASSA';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana risk değerlendirmesi, Mersin risk değerlendirmesi, Hatay risk değerlendirmesi, Osmaniye risk değerlendirmesi ve acil durum eylem planı hizmetleri. Tehlike tanımlama, risk analizi. ASSA OSGB.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana risk değerlendirmesi, Mersin risk değerlendirmesi, Hatay risk değerlendirmesi, Osmaniye risk değerlendirmesi, acil durum eylem planı, tehlike analizi');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/osgb/risk-degerlendirmesi');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Risk Değerlendirmesi ve Acil Durum Eylem Planı",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde profesyonel risk değerlendirmesi ve acil durum eylem planı hizmetleri.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "telephone": "+90-850-346-2772",
        "email": "assa@assaisg.com"
      },
      "areaServed": [
        {"@type": "City", "name": "Adana"},
        {"@type": "City", "name": "Mersin"},
        {"@type": "City", "name": "Hatay"},
        {"@type": "City", "name": "Osmaniye"}
      ],
      "serviceType": "Risk Değerlendirmesi",
      "url": "https://www.assaosgb.com.tr/osgb/risk-degerlendirmesi"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingButtons />

      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-orange-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Risk Değerlendirmesi ve Acil Durum Eylem Planı
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde risk değerlendirmesi ve acil durum eylem planı hizmetleri sunuyoruz. İşyerinizde güvenli çalışma ortamı oluşturmak için profesyonel destek sağlıyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Risk Değerlendirmesi Hizmetlerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service Card 1 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-search-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Tehlike Tanımlama</h3>
                <p className="text-gray-600">
                  İşyerindeki tüm tehlikelerin belirlenmesi ve sınıflandırılması. <strong>Adana risk değerlendirmesi</strong> hizmetlerimizle güvenli çalışın.
                </p>
              </div>

              {/* Service Card 2 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-bar-chart-box-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Risk Analizi</h3>
                <p className="text-gray-600">
                  Risklerin olasılık ve şiddet açısından değerlendirilmesi. <strong>Mersin OSGB risk değerlendirmesi</strong> ile detaylı analiz.
                </p>
              </div>

              {/* Service Card 3 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-star-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kontrol Önlemleri</h3>
                <p className="text-gray-600">
                  Riskleri azaltmak için gerekli önlemlerin belirlenmesi. <strong>Hatay OSGB</strong> bölgesinde profesyonel hizmet.
                </p>
              </div>

              {/* Service Card 4 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-alarm-warning-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Acil Durum Planı</h3>
                <p className="text-gray-600">
                  Yangın, deprem ve diğer acil durumlar için eylem planları. <strong>Osmaniye acil durum eylem planı</strong> hazırlığı.
                </p>
              </div>

              {/* Service Card 5 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-team-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Ekip Eğitimi</h3>
                <p className="text-gray-600">
                  Acil durum ekiplerinin eğitimi ve tatbikatları. <strong>Adana OSGB</strong> standartlarında eğitim programları.
                </p>
              </div>

              {/* Service Card 6 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-refresh-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Periyodik Güncelleme</h3>
                <p className="text-gray-600">
                  Risk değerlendirmelerinin düzenli olarak güncellenmesi. <strong>Mersin risk değerlendirmesi</strong> takibi.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regional Coverage */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Hizmet Bölgelerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adana OSGB</h3>
                <p className="text-gray-600">
                  Adana ve çevresinde <strong>risk değerlendirmesi</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Mersin OSGB</h3>
                <p className="text-gray-600">
                  Mersin bölgesinde profesyonel <strong>acil durum planı</strong> desteği
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Hatay OSGB</h3>
                <p className="text-gray-600">
                  Hatay'da güvenilir <strong>risk değerlendirmesi</strong> hizmetleri
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Osmaniye OSGB</h3>
                <p className="text-gray-600">
                  Osmaniye'de uzman <strong>acil durum planı</strong> hazırlığı
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-orange-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Risk Değerlendirmesi Hizmeti Almak İster misiniz?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde profesyonel risk değerlendirmesi ve acil durum eylem planı hizmetleri için bizimle iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim" 
                className="bg-white text-orange-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                Hemen İletişime Geçin
              </Link>
              <a 
                href="tel:08503462772" 
                className="bg-orange-700 text-white px-8 py-4 rounded-lg font-bold hover:bg-orange-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                0850 346 2772
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RiskDegerlendirmesiPage;
